import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import React from "react";
import { compareLanguages } from "utilities/translationUtils";

interface Props {
  allLanguages: server.dto.Language[];
  category: server.dto.ArticleCategory;
  onEdit: (category: server.dto.ArticleCategory) => void;
  onDelete: (category: server.dto.ArticleCategory) => void;
}

const CategoryRow = ({ category, allLanguages, onEdit, onDelete }: Props) => {
  const categoriesWithoutTranslations = [...allLanguages]
    .filter(language => !category.translations.some(translation => translation.language === language.value));
  const translations = [...category.translations, ...categoriesWithoutTranslations.map(language => ({ language: language.value, title: "" }))]
    .sort((a, b) => compareLanguages(a.language, b.language));

  return <tr>
    {translations.map(translation =>
      <td key={translation.language}>
        {translation.title || "<No translation>"}
      </td>)}

    <td>
      <PhosphorTrashButton
        layout="in-square"
        onClick={() => onDelete(category)} />

      <PhosphorPencilButton
        layout="in-square"
        onClick={() => onEdit(category)}
      />
    </td>
  </tr>
}

export default CategoryRow;